// Penampung pengaturan perusahaan yang sedang login (identitas cetak, batas stok menipis,
// refresh dashboard publik). JANGAN ubah nilai di sini untuk mengatur aplikasi: nilainya
// dimuat dari tabel m_perusahaan, ubah lewat menu Master > Pengaturan Perusahaan.
// Nilai di bawah hanya cadangan bila database belum bisa dibaca.
import { reactive } from 'vue'
import axios from 'axios'

const config = reactive({
  // Identitas yang tampil di header/footer dokumen cetak
  appName: 'WINA',
  companyName: 'WINA - Warehouse Inventory Application',
  companySub: '',
  companyLogo: '',
  companySlogan: '',
  address: '',
  phone: '',
  email: '',

  // Dashboard Inventory: stok <= nilai ini dianggap menipis
  lowStockThreshold: 10,

  // Dashboard publik: jeda refresh otomatis (menit)
  publicRefreshMinutes: 5,

  // FEFO: stok yang expired dalam N hari ke depan ditandai mendekati expired
  expiryWarningDays: 30,

  // Alamat API tetap di sini karena dibutuhkan sebelum database bisa dibaca
  // Alamat API; instalasi white label di hosting lain mengisi VUE_APP_API_URL saat build (lihat .env.example)
  apiUrl: process.env.VUE_APP_API_URL || 'https://woles.ptppi.co.id/api_beos/index.php/',
})

export function applyPengaturan(pengaturan) {
  if (!pengaturan) return
  Object.keys(config).forEach((key) => {
    if (key !== 'apiUrl' && pengaturan[key] !== undefined && pengaturan[key] !== null) {
      config[key] = pengaturan[key]
    }
  })
}

// Muat pengaturan perusahaan user yang sedang login
export async function loadPengaturan() {
  const idPerusahaan = localStorage.getItem('id_perusahaan')
  if (!idPerusahaan) return
  try {
    const response = await axios.post(
      (localStorage.getItem('url') || config.apiUrl) + 'master/get_pengaturan_perusahaan',
      { id_perusahaan: idPerusahaan },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-API-KEY': localStorage.getItem('key'),
        },
        timeout: 8000,
      },
    )
    if (response.data.status === 'success') applyPengaturan(response.data.data)
  } catch (err) {
    console.error('Gagal memuat pengaturan perusahaan:', err)
  }
}

export default config
